import { useCallback } from 'react';

import { ModalName } from '../../enums';
import { useDispatch, useSelector } from '../../utils';
import { closeModal, openModal } from './actions';
import { selectModalByName } from './selectors';

export const useIsModalOpened = (modalName: ModalName) =>
  useSelector((state) => selectModalByName(state, modalName).isOpen);
export const useModalProps = (modalName: ModalName) =>
  useSelector((state) => selectModalByName(state, modalName).props);

export function useOpenModal(modalName: ModalName): (props?: unknown) => void {
  const dispatch = useDispatch();

  return useCallback(
    (props?: unknown) => {
      dispatch(openModal({ modalName, props }));
    },
    [dispatch, modalName],
  );
}

export function useCloseModal(modalName: ModalName): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(closeModal({ modalName }));
  }, [dispatch, modalName]);
}
